import { useVendorRole } from '@/hooks/useVendorRole';
import SupplierMypage from './SupplierMypage';

/**
 * 마이페이지 진입점
 * - 역할에 따라 도매/소매 마이페이지로 분기
 */
const MypagePage = () => {
    const { isSupplier } = useVendorRole();

    // 현재는 도매 마이페이지만 구현
    // 소매 마이페이지는 추후 구현 예정
    if (isSupplier) {
        return <SupplierMypage />;
    }

    // 소매 사용자도 일단 같은 페이지 사용 (추후 ResellerMypage로 분리)
    return <SupplierMypage />;
};

export default MypagePage;
